import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";

const EditUserModal = ({ isEditOpen, closeEditModal }) => {
  return (
    <Modal
      show={isEditOpen}
      onHide={closeEditModal}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closeEditModal} />
        <Button text="Save Changes" callBack={closeEditModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default EditUserModal;